import { nanoid } from 'nanoid';

// HEAD DATA
export const headData = {
  title: 'Hafiz Muhammad Hammad', // e.g: 'Name | Developer'
  lang: '', // e.g: en, es, fr, jp
  description: 'Welcome to my Portfolio', // e.g: Welcome to my website
};

// HERO DATA
export const heroData = {
  title: 'Hi, this is',
  name: 'Hafiz Muhammad Hammad',
  subtitle: 'I am a Front End Developer',
  cta: '',
};

// ABOUT DATA
export const aboutData = {
  img: 'profile.jpg',
  paragraphOne: 'I am a UI Designer and Front End Developer from Karachi,Pakistan',
  paragraphTwo: 'I enjoy taking complex problems and turning them into simple and beautiful interface designs I also love the logic and structure of coding and always try to write elegant and efficient code whether it be HTML,CSS,REACT JS or Bootstrap',
  paragraphThree: 'When I am not coding, I am probably hanging out with my friends or playing video games',
  resume: '', // if no resume, the button will not show up
};

// PROJECTS DATA
export const projectsData = [
  {
    id: nanoid(),
    img: 'netflix-img.PNG',
    title: 'Netflix Clone ',
    info: 'This is a netlix clone website with firebase authantication and netflix APi',
    info2: 'I made it by using react js, Material UI, Frirebase ',
    url: 'https://netflix-clone-240a9.web.app/',
    repo: 'https://github.com/Hammad86/netflix-clone', // if no repo, the button will not show up
  },
  {
    id: nanoid(),
    img: 'ibf-img.PNG',
    title: 'IBF ',
    info: 'A simple educational website showcasing the different courses Of Institute of Business and Finance',
    info2: 'I made it by using HTML,CSS,JS,Jquery and Bootsrap ',
    url: 'https://ibf-v2.netlify.app',
    repo: 'https://github.com/Hammad86/ibf-project', // if no repo, the button will not show up
  },
  {
    id: nanoid(),
    img: 'arabic-img.PNG',
    title: 'Arabic Education ',
    info: 'A simple Landing page of an Arabic educational website showcasing the different courses',
    info2: 'I made it by using HTML,CSS,JS,Jquery and Bootsrap ',
    url: 'https://arabic-edu.netlify.app/',
    repo: 'https://github.com/Hammad86/', // if no repo, the button will not show up
  },
  {
    id: nanoid(),
    img: 'red-store.PNG',
    title: 'Red Store ',
    info: 'A simple Landing page of an E-commerce website showcasing the different products',
    info2: 'I made it by using HTML,CSS,JS,Jquery and Bootsrap ',
    url: 'https://red-shoe-store.netlify.app/',
    repo: 'https://github.com/Hammad86/red-store', // if no repo, the button will not show up
  },
  {
    id: nanoid(),
    img: 'Durrani-wear-pic.PNG',
    title: 'Durrani Wears ',
    info: 'A simple e-commerce website showcasing the different products of Durrani wears',
    info2: 'I made it by using HTML,CSS,JS and Bootsrap ',
    url: 'https://durrani-wears.netlify.app/',
    repo: 'https://github.com/Hammad86/E-commerce-store', // if no repo, the button will not show up
  },
  {
    id: nanoid(),
    img: 'Owlang-tutors-pic.PNG',
    title: 'Owlang Tutors',
    info: 'Owlang Tutors offers fully immersive, one-on-one, and group online language courses provided by highly qualified tutors.',
    info2: 'I made it by using HTML,CSS,JS and Bootsrap ',
    url: 'https://owlang-tutors.netlify.app/',
    repo: 'https://github.com/Hammad86/Education-website', // if no repo, the button will not show up
  },
  {
    id: nanoid(),
    img: 'whatsapp-img.PNG',
    title: 'Whatsapp Clone',
    info: 'Whatsapp clone with real time chat functionality and Google Authentication',
    info2: 'I made it by using react.js,Firebase and Bootsrap',
    url: 'https://whatsapp-dummy.netlify.app/',
    repo: 'https://github.com/Hammad86/whatsapp-clone', // if no repo, the button will not show up
  },
  {
    id: nanoid(),
    img: 'contact-book-pic.PNG',
    title: 'Contacts Book',
    info: 'A simple contacts book to save some other details with contact number',
    info2: 'I made it by using React.js with redux',
    url: 'https://contact-us-book.netlify.app/',
    repo: 'https://github.com/Hammad86/reduxContact-book', // if no repo, the button will not show up
  },
  {
    id: nanoid(),
    img: 'company-page-pic.PNG',
    title: 'Demo Company Website',
    info: 'A W3School  bootstarp(HTML) template of a demo company website',
    info2: 'I customize the HTML template into react by using React.js',
    url: 'https://companypage.netlify.app/',
    repo: 'https://github.com/Hammad86/company-page-demo', // if no repo, the button will not show up
  },
  {
    id: nanoid(),
    img: 'Owlkid-academy-pic.PNG',
    title: 'Owlkid Academy',
    info: 'The main goal of Owlkids Academy is to break the fear in children of speaking in a foreign language. ',
    info2: 'I made it by using HTML,CSS,JS and Bootsrap',
    url: 'https://owlkid-academy.netlify.app/',
    repo: 'https://github.com/Hammad86/Owlkids-academy', // if no repo, the button will not show up
  },
];

// CONTACT DATA
export const contactData = {
  cta: '',
  btn: '',
  email: '',
};

// FOOTER DATA
export const footerData = {
  networks: [
    {
      id: nanoid(),
      name: 'instagram',
      url: 'https://www.instagram.com/awesom_hammad/?r=nametag',
    },
    {
      id: nanoid(),
      name: 'facebook',
      url: 'https://www.facebook.com/profile.php?id=100006594164323',
    },
    {
      id: nanoid(),
      name: 'linkedin',
      url: 'https://www.linkedin.com/in/muhammad-hammad-351271185/',
    },
    {
      id: nanoid(),
      name: 'github',
      url: 'https://github.com/Hammad86',
    },
    {
      id: nanoid(),
      name: 'whatsapp',
      url: 'whatsapp://send?text=Assalam-u-alaikum&phone=+923323426686',
    },
  ],
};

// Github start/fork buttons
export const githubButtons = {
  isEnabled: true, // set to false to disable the GitHub stars/fork buttons
};
